import React, { PropsWithChildren, useState } from 'react'
import { RichTextDropdown } from './RichTextDropdown'
import { RichTextButtons } from './RichTextButtons'
import RichTextLinkEditor from './RichTextLinkEditor'
import { useRichTextToolbar } from './hooks'
import './RichTextToolbarPlugin.scss'

export interface ToolbarPluginProps {
  className?: string
  disabled?: boolean
}

export const RichTextToolbarPlugin: React.FC<PropsWithChildren<ToolbarPluginProps>> = ({ children, className, disabled = false }) => {
  const { editor, formatting, undoRedo } = useRichTextToolbar()

  const [portalDiv, setPortalDiv] = useState<HTMLDivElement | null>(null)

  return (
    <>
      <div ref={setPortalDiv} className={`d-flex flex-wrap row-gap-1 rich-text-container ${className ?? ''}`}>
        <div className='flex-grow-1 mw-0'>
          <RichTextDropdown editor={editor} formatting={formatting} disabled={disabled} />
        </div>
        <RichTextButtons formatting={formatting} undoRedo={undoRedo} disabled={disabled} />
        {portalDiv ? <RichTextLinkEditor editor={editor} formatting={formatting} anchorElem={portalDiv} /> : null}
      </div>
      {children}
    </>
  )
}
